import { render, staticRenderFns } from "./CalendarioSeleccionableFestivos.vue?vue&type=template&id=78d7e0cf&scoped=true&"
import script from "./CalendarioSeleccionableFestivos.vue?vue&type=script&lang=ts&"
export * from "./CalendarioSeleccionableFestivos.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarioSeleccionableFestivos.vue?vue&type=style&index=0&id=78d7e0cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7e0cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VIcon,VRow})
